import React from 'react';
import { Link } from 'react-router';
import './LegalPages.css';
import logo from '../assets/logo_prime.webp';
import backgroundImage from '../assets/image.png';
import Footer from './Footer';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="legal-container">
        <div className="legal-header">
          <Link to="/" className="logo-link">
            <img src={logo} alt="Prime Telehealth" className="legal-logo" />
          </Link>
          <h1>Privacy Policy</h1>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Introduction</h2>
            <p>
              Welcome to Prime Telehealth ("we," "our," or "us"). This Privacy Policy explains how we collect,
              use, disclose, and safeguard your information when you use our telehealth platform and related services
              (collectively, the "Service"). Please read this Privacy Policy carefully.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <p>We may collect the following types of personal information:</p>
            <ul>
              <li>Name, email address, phone number, and date of birth</li>
              <li>Medicare number and health fund details</li>
              <li>Medical history, symptoms, and health-related information</li>
              <li>Payment and billing information</li>
              <li>Profile pictures and other profile information</li>
            </ul>

            <h3>2.2 Usage Information</h3>
            <p>We automatically collect certain information about your use of our Service:</p>
            <ul>
              <li>Device information (device type, operating system, unique device identifiers)</li>
              <li>Log information (IP address, browser type, pages visited, time spent)</li>
              <li>Location information (with your consent)</li>
              <li>Communication data (messages between patients and doctors)</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use the collected information for the following purposes:</p>
            <ul>
              <li>To provide and maintain our Service</li>
              <li>To facilitate doctor-patient consultations</li>
              <li>To process Medicare claims and health fund rebates</li>
              <li>To process payments and manage billing</li>
              <li>To send you important updates and notifications</li>
              <li>To improve our Service and develop new features</li>
              <li>To comply with Australian legal obligations and healthcare regulations</li>
              <li>To protect against fraud and abuse</li>
            </ul>
          </section>

          <section>
            <h2>4. Information Sharing and Disclosure</h2>
            <p>We may share your information in the following circumstances:</p>
            <ul>
              <li>
                <strong>With Healthcare Providers:</strong> Your medical information is shared with Australian registered
                doctors and healthcare professionals you choose to consult with
              </li>
              <li>
                <strong>Medicare and Health Funds:</strong> With Medicare Australia and your health fund for claim processing and
                rebates
              </li>
              <li>
                <strong>Service Providers:</strong> With third-party companies that help us operate our Service
              </li>
              <li>
                <strong>Legal Requirements:</strong> When required by Australian law or to protect our rights and safety
              </li>
              <li>
                <strong>Business Transfers:</strong> In connection with mergers, acquisitions, or asset sales
              </li>
              <li>
                <strong>With Your Consent:</strong> When you explicitly authorize us to share your information
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information
              against unauthorized access, alteration, disclosure, or destruction. This includes:
            </p>
            <ul>
              <li>Encryption of data in transit and at rest</li>
              <li>Regular security assessments and updates</li>
              <li>Access controls and authentication measures</li>
              <li>Employee training on data protection</li>
            </ul>
          </section>

          <section>
            <h2>6. Your Rights and Choices</h2>
            <p>You have the following rights regarding your personal information:</p>
            <ul>
              <li><strong>Access:</strong> Request access to your personal information</li>
              <li><strong>Correction:</strong> Request correction of inaccurate information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information</li>
              <li><strong>Portability:</strong> Request a copy of your data in a portable format</li>
              <li><strong>Opt-out:</strong> Opt out of certain communications and data processing</li>
            </ul>
          </section>

          <section>
            <h2>7. Data Retention</h2>
            <p>
              We retain your personal information for as long as necessary to provide our Service and comply
              with Australian legal obligations. Medical records may be retained for longer periods as required by
              Australian healthcare regulations and the Australian Privacy Act 1988.
            </p>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>
              Our Service is not intended for children under 13 years of age. We do not knowingly collect
              personal information from children under 13. If you are a parent or guardian and believe your
              child has provided us with personal information, please contact us.
            </p>
          </section>

          <section>
            <h2>9. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by
              posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our privacy practices, please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> primetelehealthau@gmail.com</p>
              <p><strong>Phone:</strong> +61 469 755977</p>
              <p><strong>Address:</strong> 10 Trevithick Close, Stirling Western Australia 6021, Australia</p>
            </div>
          </section>
        </div>

        <div className="legal-footer">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
